import React from 'react';

import {FormattedMessage} from 'react-intl';
import Helmet from 'react-helmet';
import { getCompanyName } from './domainUtils'

const LocalizedDocumentMeta = ({title, description, keywords}) => {
  const companyName = getCompanyName();
  const currentUrl = window.location.href;
  return (
        <FormattedMessage {...title} values={{ companyName }}>
            {(titleString) =>
                <FormattedMessage {...description} values={{ companyName }}>
                    {(descriptionString) =>
                      <FormattedMessage {...keywords} values={{ companyName }}>
                          {(keywordsString) =>
                                <Helmet
                                  title={titleString}
                                  meta={[
                                      {
                                          "name": "description",
                                          "content": descriptionString
                                      },
                                      {
                                          "name": "keywords",
                                          "content": keywordsString
                                      }
                                  ]}
                                  link={[
                                    {rel: 'canonical', href: currentUrl}
                                  ]}
                                />
                          }
                      </FormattedMessage>
                    }
                </FormattedMessage>
            }
        </FormattedMessage>
    );
};

export {LocalizedDocumentMeta};

export default LocalizedDocumentMeta;



// WEBPACK FOOTER //
// ./js/shared/LocalizedDocumentMeta.jsx